import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'
import getLoyaltyAccountRegion from './getLoyaltyAccountRegion'

const getCanShowRegionSpecificLoyaltyUI = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => getLoyaltyAccountRegion(state),
  (isEnabled, currentRegion, accountRegion): boolean => {
    if (!isEnabled) return false
    // If account region is unknown (not fetched yet), hide to be safe
    if (!accountRegion) return false
    // Only show in booking flow when account region matches current site region
    return currentRegion === accountRegion
  },
)

export default getCanShowRegionSpecificLoyaltyUI
